class QueryParams {
  public static readonly Code = "code";
}

export default QueryParams;
